import React from 'react';
import { FaBus } from 'react-icons/fa';

const Busloader = ({ from, to, departDate }) => {
    return (
        <div className="flex items-center justify-center px-4 py-12">
            <div className="bg-white rounded-2xl border border-ink-100 shadow-card px-8 py-10 sm:px-12 sm:py-12 text-center max-w-sm w-full">
                <div className="relative h-16 w-16 mx-auto mb-6">
                    <div className="absolute inset-0 rounded-full border-4 border-brand-100" />
                    <div className="absolute inset-0 rounded-full border-4 border-transparent border-t-brand-600 animate-spin" />
                    <div className="absolute inset-0 flex items-center justify-center">
                        <FaBus className="text-brand-600" size={18} />
                    </div>
                </div>

                <h5 className="text-lg font-bold text-ink-900 mb-1.5">Please wait...</h5>
                <p className="text-sm text-ink-500 mb-5">We are looking for all available buses for you</p>

                {from && to ? (
                    <div className="border-t border-ink-100 pt-4 space-y-1">
                        <div className="text-sm font-semibold text-ink-700">
                            {from} <span className="text-ink-300">&rarr;</span> {to}
                        </div>
                        {departDate && (
                            <div className="text-xs text-ink-400">Departure: {departDate}</div>
                        )}
                    </div>
                ) : (
                    <div className="text-sm text-ink-400 border-t border-ink-100 pt-4">Searching for buses...</div>
                )}
            </div>
        </div>
    );
};

export default Busloader;
